export var SearchParamType;
(function (SearchParamType) {
    SearchParamType["WHAT"] = "q";
    SearchParamType["WHERE"] = "l";
    SearchParamType["CURSOR"] = "c";
    SearchParamType["IS_REMOTE_ONLY"] = "ro";
    SearchParamType["COUNTRY"] = "co";
    SearchParamType["JOB_KEY"] = "jk";
    SearchParamType["COMPANY"] = "com";
    SearchParamType["DATE_POSTED"] = "date";
    SearchParamType["JOB_CATEGORY_SUID"] = "occ";
    SearchParamType["JOB_TYPE_SUID"] = "jt";
})(SearchParamType || (SearchParamType = {}));
